import hubLayout from 'styles/css/hubLayout.module.css';
import styled from "styled-components";
import { decryptAES256, encryptAES256, getRecorderDdnsEventOne, getUserListForEvent, toUrlSafeBase64 } from 'api/api';
import { useCallback, useEffect, useState } from 'react';
import Loading from 'components/common/Loading';
import { useModal } from 'components/common/ModalLayout';
import { Events } from 'type/type';
import { useNavigate } from 'react-router-dom';

const InfoSection = styled.div`  
  .info_wrap {
    padding: 1.5rem 0.5rem;
  }
  
  .info_title {
    font-size: 1.125rem;
    margin-bottom: 1rem;
    padding: 0.5rem 0;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    border-bottom: 1px solid #121212;
  }
  
  .info_content {
    > div {
      position: relative;
      padding-left: 1rem;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    label {
      width: 8rem;
      font-size: 14px;
      font-weight: 600;
      color: #262626;
    }
    span {
      width: 100%;
      padding: 5px 15px;
      font-size: 14px;
      line-height: 20px;
      white-space: pre-wrap;
      word-break: break-all;
      overflow-wrap: break-word;
    }
  }
`;

function EventDetail() {
  const navigate = useNavigate();
  const { showModal } = useModal();
  const [loading, setLoading] = useState(true);
  const [event, setEvent] = useState<Events>(Object);
  const [kakaoMonitorHandled, setKakaoMonitorHandled] = useState<string>('');

  const openApp = async () => {
    navigate(`/focusview?kakao_monitor_handled=${kakaoMonitorHandled}`);
  };

  const getEventDetail = useCallback(async () => {
    setLoading(true);
    try {
      const searchParams = new URLSearchParams(window.location.search);
      const encryptData = searchParams.get('data');
      // const testKey = generateSecureRandomString();
      // const encryptDatatest = `${testKey}${encryptAES256('{"tbl": "event_202504", "idx": 5201280, "eType": "침입감지", "reg_name": "SIDE"}', testKey, testKey.slice(0, 16))}`;
      
      if (!encryptData) {
        return showModal("alert", "유효하지 않은 값입니다.", { confirm: true, cancel: true });
      }

      // 데이터 복호화
      const key = encryptData.slice(0, 32);
      const iv = key.slice(0, 16);
      const encryptStr = encryptData.slice(32);
      const data = decryptAES256(encryptStr, key, iv);
      const eventInfo = JSON.parse(data);

      if (!eventInfo.idx || !eventInfo.tbl) {
        return showModal("alert", "유효하지 않은 값입니다.", { confirm: true, cancel: true });
      }
      // 서버로 이벤트 정보 요청
      const response = await getRecorderDdnsEventOne(Number(eventInfo.idx), eventInfo.tbl);
      if (response.code === 200) {
        setEvent({
          ...response.data,
          eType: eventInfo.eType,
          reg_name: eventInfo.reg_name,
        });

        const userRes = await getUserListForEvent(toUrlSafeBase64(encryptAES256(response.data.mac, process.env.REACT_APP_SECRET_KEY!, process.env.REACT_APP_SECRET_IV!)));
        if (userRes.code === 200 && userRes.data.length > 0) {
          const date = new Date(response.data.eDate);
          const timestamp = Math.floor(date.getTime() / 1000); // 초 단위
          setKakaoMonitorHandled(encodeURIComponent(`mac=${response.data.mac}&user=${userRes.data[0].id}&ch=${response.data.eCh}&time=${timestamp}`));
        }
      } else {
        return showModal("alert", response.message);
      }
    } catch (error) {
      console.log(error);
      return showModal("alert", "유효하지 않은 값입니다.(Error)", { confirm: true, cancel: true });
    } finally {
      setLoading(false);
    }
  }, []);
  
  useEffect(() => {
    getEventDetail();
  },[getEventDetail]);
  return (
    <>
      {loading ? <Loading /> :
        <InfoSection style={{ overflowY: "auto", height: "100%" }}>
          <div className={`${hubLayout.acc__cnt}`}>
            <h2 className={`${hubLayout.cnt_title}`} style={{ textAlign: "center" }}>
              <img src="/image/FOCUSAI_Blue_Black.png" style={{ width: "50%" }} alt='FOCUSAI_Blue_Black' />
            </h2>
            <div className="info_wrap">
              <div className="info_title">
                <h4>Event 상세 정보 알림</h4>
              </div>
              <p style={{ padding: '0.5rem 0.5rem 1.5rem', fontSize: '15px' }}>
                고객님의 사업장에서 중요한 이벤트가 탐지되었습니다.<br />
                안전을 위해 아래 내용을 확인해 주세요.
              </p>
              <div className="info_content">
                <div>
                  <label>상호명</label>
                  <span>{event.reg_name}</span>
                </div>
                <div>
                  <label>발생일시</label>
                  <span>{event.eDate}</span>
                </div>
                <div>
                  <label>이벤트종류</label>
                  <span>{event.eType}</span>
                </div>
                <div>
                  <label>발생채널</label>
                  <span>{event.eCh}</span>
                </div>
                <div>
                  <label>상세 설명</label>
                  <span>{event.processDetail}</span>
                </div>
              </div>
              <div className={`${hubLayout.btn_group} ${hubLayout.fixed_bottom_title} ${hubLayout.back_white}`}>
                <button type="button" className={`${hubLayout.btn} ${hubLayout.large} ${hubLayout.blue}`} onClick={openApp}>Focus View APP 실행</button>
              </div>
            </div>
          </div>
        </InfoSection>
      }
    </>
  );
}

export default EventDetail;